import {ValidationError} from "./validation";

export function validateRequiredTrimmed(value: string, errorKey: string): ValidationError | null {
    if (!value.trim()) {
        return {key: errorKey};
    }
    return null;
}
